import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import AloWellNessLogo from '../../../assets/images/alowellnesslogo.svg'

const AlomovesIcon = ({ color = 'black', width = '30px', height = '30px' }) => (
  <ResponsiveSVG
    width={width}
    height={height}
    className='unstyled'
    fill={color}
    SVG={AloWellNessLogo}
  />
)

export default AlomovesIcon
